import { render, staticRenderFns } from "./UrgencyQueue.vue?vue&type=template&id=d68d4aca&scoped=true&lang=pug"
import script from "./UrgencyQueue.vue?vue&type=script&lang=js"
export * from "./UrgencyQueue.vue?vue&type=script&lang=js"
import style0 from "./UrgencyQueue.vue?vue&type=style&index=0&id=d68d4aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68d4aca",
  null
  
)

export default component.exports